var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourwickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 40,
    viewBox: "0 0 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V15.7C20 16.4667 19.8333 17.15 19.5 17.75C19.1667 18.35 18.7 18.8333 18.1 19.2L11 23.4L12.4 28H20L13.8 32.4L16.2 40L10 35.3L3.8 40L6.2 32.4L0 28H7.6L9 23.4L1.9 19.2C1.3 18.8333 0.833333 18.35 0.5 17.75C0.166667 17.15 0 16.4667 0 15.7V0ZM4 4V15.7L8 18.1V4H4ZM16 4H12V18.1L16 15.7V4Z",
    fill: "#FF6A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourwickets);
export default __webpack_public_path__ + "static/media/Fourwickets.f8b18618b323f1f97e967d8c320f4ceb.svg";
export { ForwardRef as ReactComponent };